<template>
<span 
  class="is-flex flex-column align-items-center">
  <span class="is-flex">
    <icon icon="globe"/>
  </span>
  <small>view app</small>
</span>
</template>
<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>